/**
 * @generated SignedSource<<c19c1ab96008814a8d6ad747407e868a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CutOffListPage_page$data = {
  readonly breadcrumbs: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"Breadcrumb_data">;
  } | null | undefined> | null | undefined;
  readonly components: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly __typename: string;
        readonly " $fragmentSpreads": FragmentRefs<"CutOffList_component" | "Widget_component">;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly id: string;
  readonly path: string | null | undefined;
  readonly " $fragmentType": "CutOffListPage_page";
};
export type CutOffListPage_page$key = {
  readonly " $data"?: CutOffListPage_page$data;
  readonly " $fragmentSpreads": FragmentRefs<"CutOffListPage_page">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CutOffListPage_page",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 10000
        }
      ],
      "concreteType": "ComponentConnection",
      "kind": "LinkedField",
      "name": "components",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ComponentEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "CutOffList_component"
                },
                {
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "salesAdmission",
                      "value": "AT"
                    }
                  ],
                  "kind": "FragmentSpread",
                  "name": "Widget_component"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "components(first:10000)"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Breadcrumb",
      "kind": "LinkedField",
      "name": "breadcrumbs",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "Breadcrumb_data"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "path",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "CutOffPage",
  "abstractKey": null
};

(node as any).hash = "b1a12cc23211fe71c625378584f01412";

export default node;
